import {ModuleWithProviders} from '@angular/core';
import {RouterModule, Routes} from '@angular/router';
import {MisComponent} from './mis.component';
import {QualityIndicatorsModule} from './quality-indicators/quality-indicators.module';

const routes: Routes = [
    {
        path: 'mis', component: MisComponent,
        children: [
            {path: 'mis-emergency', loadChildren: './mis-emergency/mis-emergency.module#MisEmergencyModule'},
            {path: 'mis-opd', loadChildren: './mis-opd/mis-opd.module#MisOpdModule'},
            {path: 'mis-ipd', loadChildren: './mis-ipd/mis-ipd.module#MisIpdModule'},
            {path: 'mis-pharmacy', loadChildren: './mis-pharmacy/mis-pharmacy.module#MisPharmacyModule'},
            {path: 'mis-billing', loadChildren: './mis-billing/mis-billing.module#MisBillingModule'},
            {path: 'mis-inventory', loadChildren: './mis-inventory/mis-inventory.module#MisInventoryModule'},
            {path: 'mis-ot', loadChildren: './mis-ot/mis-ot.module#MisOtModule'},
            {path: 'mis-nursing-station', loadChildren: './mis-nursing-station/mis-nursing-station.module#MisNursingStationModule'},
            {path: 'mis-misc', loadChildren: './mis-misc/mis-misc.module#MisMiscModule'},
            {path: 'mis-investigation', loadChildren: './mis-investigation/mis-investigation.module#MisInvestigationModule'},
            {path: 'bi', loadChildren: './bi/bi.module#BiModule'},
            {path: 'mis-investigation', loadChildren: './mis-investigation/mis-investigation.module#MisInvestigationModule'},
            {path: 'mis-service', loadChildren: './mis-service/mis-service.module#MisServiceModule'},
            {path: 'opd-tally', loadChildren: './opd-tally/opd-tally.module#OpdTallyModule'},
            {path: 'user-audit', loadChildren: './user-audit/user-audit.module#UserAuditModule'},
            {path: 'quality-indicators', loadChildren: './quality-indicators/quality-indicators.module#QualityIndicatorsModule'}
        ]
    }
];
export const routing: ModuleWithProviders = RouterModule.forChild(routes);



// WEBPACK FOOTER //
// D:/CODE_REPOSITORIES/HIMS/HIMS_FRONTEND/src/app/mis/mis.routing.ts